import { ButtonHTMLAttributes } from "react";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

export default function CustomButton({
  loading = false,
  children,
  ...rest
}: Props) {
  return (
    <button disabled={loading} {...rest}>
      {loading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            style={{ color: "white" }}
          ></span>
          <span>{children}</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
